import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { RepositorySortMode } from "../types";

interface RepositorySortSelectProps {
  value: RepositorySortMode;
  onChange: (value: RepositorySortMode) => void;
}

const RepositorySortSelect = ({ value, onChange }: RepositorySortSelectProps) => {
  return (
    <Select value={value} onValueChange={(next) => onChange(next as RepositorySortMode)}>
      <SelectTrigger className="w-[220px]">
        <SelectValue placeholder="Sort repositories" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="favorites">Favorites first</SelectItem>
        <SelectItem value="nameAsc">Name A-Z</SelectItem>
        <SelectItem value="updatedDesc">Recently updated</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default RepositorySortSelect;
